// extracted by mini-css-extract-plugin
export default {"noticeContainer":"acconomy-acconomy-setup-page_noticeContainer","activateButton":"acconomy-acconomy-setup-page_activateButton"};